<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  
}
</script>

<style lang="scss">
html {
  font-size:100px;
}
html,body,#app{
  width: 100%;
  max-width: 812px;
  margin:  0 auto;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.amap-copyright{
   display: none!important;
 }
</style>
